<script>
    import {network, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import AboutApp from '../components/AboutApp.svelte';
    import BottomMenu from '../components/BottomMenu.svelte';
    
    const user = store('credential', 'getAuth');
    
    const fetch = async () => {
        let data = await network.fetch_material();
    }
    
    let wrapper;
</script>

<TopMenu title="Профиль" />

<div class="extraHeader">
    <ul class="nav nav-tabs lined" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" href="#profile" role="tab" aria-selected="false">
                Ваши данные
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link " data-bs-toggle="tab" href="#about" role="tab" aria-selected="true">
                О приложении
            </a>
        </li>
    </ul>
</div>

<div id="appCapsule" class="extra-header-active" bind:this={wrapper}>
    <div class="tab-content mt-2">
        <!-- profile tab -->
        <div class="tab-pane fade active show" id="profile" role="tabpanel">
            <ul class="listview">
                <li>
                    <div class="in">
                        <div>
                            <header>Имя</header>
                            <b>{$user.name}</b>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="in">
                        <div>
                            <header>Электронная почта</header>
                            <b>{$user.email}</b>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="in">
                        <div>
                            <header>Телефон</header>
                            <b>{$user.tel}</b>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="in">
                        <div>
                            <header>Юридическое лицо</header>
                            <b>{$user.kontr}</b>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- * profile tab -->
    
        <!-- about tab -->
        <div class="tab-pane fade" id="about" role="tabpanel">
            <AboutApp/>
        </div>
        <!-- * about tab -->
    </div>
</div>

<BottomMenu />
